import { DEFAULT_STATE } from '../routes/event-create/constants';

const initialState = {
  eventData: DEFAULT_STATE,
  savedEventData: DEFAULT_STATE,
  businessConfig: {},
  isEventImageUploading: false,
  priceBreakups: {},
};

export default (state = initialState, action) => {
  const { type, data } = action;

  switch(type) {
  case 'EVENT_CREATE:EVENT_DATA:SET':
    return {
      ...state,
      eventData: data,
    };
  case 'EVENT_CREATE:SAVED_EVENT_DATA:SET':
    return {
      ...state,
      savedEventData: data,
    };
  case 'EVENT_CREATE:BUSINESS_CONFIG:SET':
    return {
      ...state,
      businessConfig: data,
    };
  case 'EVENT_CREATE:IS_IMAGE_UPLOADING:SET':
    return {
      ...state,
      isEventImageUploading: data,
    };
  case 'EVENT_CREATE:PRICE_BREAKUP:SET':
    return {
      ...state,
      priceBreakups: { ...state.priceBreakups, [action.price]: data },
    };
  case 'EVENT_CREATE:RESET':
    return {
      ...state,
      ...initialState,
    };
  default:
    return state;
  }
}